import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ResponsiveContext, Box, Text, RadioButton, Button, Anchor } from 'grommet';
import { Placeholder } from '../../../components';

import { clearDetails, loadData } from '../actions/details';
import { createAnswer, changeChosenOption } from '../actions/form-vote';
import { toggleRealizationLayer } from '../actions/realization';
import { toggleAboutLayer } from '../actions/about';

class SurveyComponent extends Component {
  constructor(props) {
    super(props);

    const { identifier } = this.props.match.params;
    const { clearDetails, loadData } = this.props;

    clearDetails();
    loadData(identifier);
  }

  handlerPost = formParams => {
    const { createAnswer } = this.props;
    createAnswer(formParams);
  }

  render() {
    const {
      survey,
      clientProfile,

      getDetailError,

      chosenOption,
      loadingPostForm,
      postDataSuccess,
      changeChosenOption,

      toggleRealizationLayer,
      toggleAboutLayer,
    } = this.props;

    const { identifier } = this.props.match.params;

    if(!getDetailError && !survey) {
      return <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    }

    if(getDetailError) {
      return <Placeholder
        title='Opss...'
        message={`A enquete (código: ${identifier}) que esta buscando não existe mais ou já foi encerrada.`}
      />
    }

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Box
            background={survey.color}
            align='center'
            justify='center'
            height='100vh'
            pad={{ vertical: 'small', horizontal: 'small' }}
            gap={ size === 'small' ? 'medium' : 'small' }
          >
            <Box
              width={ size === 'small' || size === 'medium' ? 'large' : 'medium' }
              background='white'
              round='xsmall'
              flex={{ shrink: 0 }}
            >
              {postDataSuccess ? (
                <Box
                  pad={
                    size === 'small' ? 'large' : 'medium'
                  }
                >
                  <Text size='large' textAlign='center'>
                    {survey.thanksText || 'Obrigado por participar dessa enquete!'}
                  </Text>
                </Box>
              ) : (
                <>
                  <Box
                    pad={ size === 'small' ? 'large' : 'medium' }
                    border={{
                      side: 'bottom',
                      color: 'light-4'
                    }}
                  >
                    <Text size='large' textAlign='center'>
                      {survey.question}
                    </Text>
                  </Box>

                  <Box
                    pad={ size === 'small' ? 'large' : 'medium' }
                    gap={ size === 'small' ? 'medium' : 'small' }
                  >
                    {survey.options.map((item) => {
                      return (
                        <RadioButton
                          name='type'
                          key={item.id}
                          value={item.id}
                          label={
                            <Text size='small'>{item.op}</Text>
                          }
                          checked={chosenOption === item.id.toString()}
                          onChange={event =>
                            changeChosenOption(event.target.value)
                          }
                        />
                      )
                    })}
                  </Box>

                  <Box
                    pad={
                      size === 'small' ? 'large' : 'medium'
                    }
                  >
                    <Button
                      color={survey.color}
                      primary
                      label={
                        <Text color='white' weight='normal'>
                          { loadingPostForm ? 'REGISTRANDO...' : 'PARTICIPAR' }
                        </Text>
                      }
                      disabled={ loadingPostForm || !chosenOption }
                      onClick={() => {
                        const cDate = new Date();

                        this.handlerPost({
                          payload: {
                            identifier,
                            createdAt: cDate.toISOString(),
                            option: chosenOption,
                          },
                          header: {
                            identifier,
                            expirationDate: new Date(cDate.getFullYear(), cDate.getMonth(), cDate.getDate(), cDate.getHours(), cDate.getMinutes() + 1, cDate.getSeconds()).toISOString(),
                          }
                        })
                      }}
                    />
                  </Box>
                </>
              )}
            </Box>


            <Box
              width={ size === 'small' || size === 'medium' ? 'large' : 'medium' }
              direction='row'
              justify='between'
            >
              {clientProfile && <Anchor
                color='white'
                label='Sobre está enquete'
                size='small'
                onClick={() => toggleRealizationLayer({ open: true, clientProfile }) }
              />}

              <Anchor
                color='white'
                label='Sobre'
                size='small'
                onClick={() => toggleAboutLayer({ open: true }) }
              />
            </Box>
          </Box>
        )}
      </ResponsiveContext.Consumer>
    )
  }
}

const mapStateToProps = ({ homeReducer: { details, formVote } }) => ({
  survey: details.survey,
  clientProfile: details.clientProfile,

  getDetailError: details.getDetailError,

  chosenOption: formVote.chosenOption,
  postDataSuccess: formVote.postDataSuccess,
  loadingPostForm: formVote.loadingPostForm,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    clearDetails,
    createAnswer,
    changeChosenOption,
    loadData,

    toggleRealizationLayer,
    toggleAboutLayer,
  }, dispatch)

export const Survey = withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyComponent));
